import { useCallback, useEffect, useState } from 'react';

/**
 * Die Zeilenhoehe der Listen -- F1-41.
 *
 * Zwei Stufen: bequem und eng. Die enge zeigt rund ein Drittel mehr Zeilen,
 * ohne dass jemand blaettert -- fuer den, der den ganzen Tag Listen liest.
 * Die bequeme bleibt die Vorgabe: Wer die Anwendung zum ersten Mal oeffnet,
 * soll nicht in eine Tabellenkalkulation blicken.
 *
 * **Gespeichert wird im Browser und nicht beim Server.** Es ist eine
 * Einstellung des Arbeitsplatzes und keine der Person: Wer am grossen
 * Bildschirm eng arbeitet, will es am Laptop womoeglich nicht. Und es sind
 * keine personenbezogenen Daten -- eine Zeile im Server, die pro Nutzer
 * festhaelt, wie er seine Tabellen mag, waere eine Zeile mehr im
 * Verzeichnis der Verarbeitungstaetigkeiten fuer nichts.
 *
 * Gesetzt wird ein Attribut am Wurzelelement; die Umschaltung ist damit eine
 * Zeile CSS und keine Verzweigung in jeder Tabelle.
 */
export type Density = 'comfortable' | 'compact';

const STORAGE_KEY = 'itscrm.density';

function read(): Density {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'compact' ? 'compact' : 'comfortable';
  } catch {
    // Ein Browser, der den Speicher verweigert (privates Fenster, gesperrte
    // Website-Daten), darf die Anwendung nicht anhalten. Dann gilt die
    // Vorgabe -- fuer diese Sitzung.
    return 'comfortable';
  }
}

export function useDensity(): [Density, (next: Density) => void] {
  const [density, setDensity] = useState<Density>(read);

  useEffect(() => {
    document.documentElement.dataset.density = density;
  }, [density]);

  const change = useCallback((next: Density) => {
    setDensity(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Siehe oben: Die Einstellung gilt dann nur fuer diese Sitzung.
    }
  }, []);

  return [density, change];
}
